var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5375 3.75C14.5375 3.90625 14.5375 4.03125 14.5375 4.1875C14.5375 8.53125 11.2563 13.5 5.225 13.5C3.35 13.5 1.63125 12.9688 0.19375 12.0312C0.44375 12.0625 0.69375 12.0938 0.975 12.0938C2.50625 12.0938 3.9125 11.5625 5.0375 10.6875C3.6 10.6562 2.38125 9.71875 1.975 8.40625C2.19375 8.4375 2.38125 8.46875 2.6 8.46875C2.88125 8.46875 3.19375 8.40625 3.44375 8.34375C1.94375 8.03125 0.81875 6.71875 0.81875 5.125V5.09375C1.25625 5.34375 1.7875 5.46875 2.31875 5.5C1.4125 4.90625 0.85 3.90625 0.85 2.78125C0.85 2.15625 1.00625 1.59375 1.2875 1.125C2.9125 3.09375 5.35 4.40625 8.06875 4.5625C8.00625 4.3125 7.975 4.0625 7.975 3.8125C7.975 2 9.44375 0.53125 11.2563 0.53125C12.1938 0.53125 13.0375 0.90625 13.6625 1.5625C14.3813 1.40625 15.1 1.125 15.725 0.75C15.475 1.53125 14.975 2.15625 14.2875 2.5625C14.9438 2.5 15.6 2.3125 16.1625 2.0625C15.725 2.71875 15.1625 3.28125 14.5375 3.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.3ef352971f010ff397651d4221eda890.svg";
export { ForwardRef as ReactComponent };